import { RequirementAvailabilityIndexItem } from '@agency/apis/acquisitions';
import { DisposalRecordFloorUnit } from '@agency/apis/disposals';
import { Option } from '@shared/components/select-new/Select';
import { AvailableSpace } from '@shared/models/space';
import { AvailabilityScheduleConfig, ScheduleMatchStatusActions } from '@shared/types/common/match';

export const getMatchScheduleMatchOptions = (
  scheduleConfig: AvailabilityScheduleConfig,
  items: RequirementAvailabilityIndexItem[]
): Option[] => {
  const statusesFiltered = scheduleConfig.scheduleGroupsActive.reduce<string[]>((result, group) => {
    //@ts-ignore
    scheduleConfig.groupConfig[group].statuses.forEach((status) => {
      if (scheduleConfig.statusActionsMap[status] !== ScheduleMatchStatusActions.Complete) {
        result.push(status.toString());
      }
    });

    return result;
  }, []);

  return items
    .sort((x, y) => scheduleConfig.statuses.indexOf(x.status) - scheduleConfig.statuses.indexOf(y.status))
    .reduce<Option[]>((result, item) => {
      if (statusesFiltered.includes(item.status.toString()) && !item.discounted_reason) {
        const addressStr = `${item.address_name}${item.address ? `, ${item.address}` : ''}`;
        const statusLabel = scheduleConfig.statusLabelsMap[item.status];
        result.push({
          id: item.id,
          label: `${addressStr}  - (${statusLabel})`,
        });
      }
      return result;
    }, []);
};

export const convertAvailabilityScheduleSpacesToFloorUnits = (
  spaces: AvailableSpace[],
  propertyId: number
): DisposalRecordFloorUnit[] => {
  const units: DisposalRecordFloorUnit[] = [];
  spaces.forEach((f_unit) => {
    if (
      f_unit.status === 4 ||
      f_unit.status === 5 ||
      f_unit.status === 6 ||
      f_unit.status === 7 ||
      f_unit.status === 8
    ) {
      return;
    }

    const propertyTypes = f_unit.content.building_types
      ? f_unit.content.building_types.split(',').map((t) => t.trim())
      : [];

    units.push({
      floor_string: f_unit.floor_string,
      floor_unit_id: null,
      floor: f_unit.floor_identifier,
      id: f_unit.id,
      include: 1,
      part_floor: f_unit.part_floor,
      property_id: propertyId,
      property_types: propertyTypes,
      size_metric: f_unit.content.size.metric,
      size_value_sqft: f_unit.content.size.value_sqft ?? null,
      size_value: f_unit.content.size.value.toString(),
      unit: f_unit.floor_description,
      unit_string: f_unit.floor_description ?? '',
      status: f_unit.status_string,
    });
  });

  return units;
};
